import { SET_ALL_DATA_OF_CONTACT_STATE } from './AllDataOfContactTypes';
import { SET_SEARCHED_DATA_OF_CONTACT_STATE } from './AllDataOfContactTypes';

// Redux actions start 

export const setAllDataOfContact = (allDataOfContactValue) => {
    
    return {
        type: SET_ALL_DATA_OF_CONTACT_STATE,
        payload: allDataOfContactValue
    }
}

export const setSearchedDataOfContact = (results) => ({

    type: SET_SEARCHED_DATA_OF_CONTACT_STATE,
    payload: results

  });

// Redux actions end